  import { USA } from '../constants';
import {BAOSYSTEMS_DOMAIN, CUSTOMER_DOMAIN, PURCHASE_DOMAIN} from "../constants/common";

const mapToFormSubmissionEntity = formData => {
  let instances = formData.instances || {};
  instances = instances.instances || {};
  const { addOns = {} } = formData;
  const { servicePeriod, automaticallyRenew, instanceLaunchDate } = instances.instancesSetup || {};
  const _instances = Object.keys(instances)
    .filter(id => id !== 'instancesSetup')
    .map(instanceId => {
      const instance = instances[instanceId] || {};
      const {
        urlType,
        url,
        dhisVersion,
        instancePurpose,
        hostingPlan,
      } = instance;
      const regions = {};
      Object.keys(instance).forEach(key => {
        if (key.startsWith('regions.'))
          regions[key.replace('regions.', '')] = instance[key];
      });

      const purchaseDomain = urlType === PURCHASE_DOMAIN;
      return {
        dhisVersion,
        hostingPlan: typeof hostingPlan === 'string' && hostingPlan.toUpperCase(),
        instancePurpose,
        regions,
        url: urlType === CUSTOMER_DOMAIN ? url : BAOSYSTEMS_DOMAIN,
        urlType,
        purchaseDomain
      };
    });

  const {
    contactInformation,
    billing: {
      name: billingContactName,
      email: billingContactEmail,
      billingAddress,
      city,
      state,
      usaState,
      postalCode,
      country,
      poNumber,
      phoneNumber,
      billingFrequency,
      createFinanceUser
    }
  } = formData;

  const {
    differentContact_name,
    differentContact_email,
    differentContact_phone,
    contactSameAsPrimary
  } = contactInformation;

  const technicalContactInfo = !contactInformation.hasOwnProperty('contactInformation') || contactSameAsPrimary ?
    {
    ref: "primaryContact"
    } : {
      info: {
        name: differentContact_name,
        email: differentContact_email,
        phoneNumber: differentContact_phone
      }
  };

  return {
    name: contactInformation.organization,
    clientOrganization: contactInformation.clientOrganization,
    primaryContact: {
      info: {
        name: contactInformation.name,
        email: contactInformation.email,
        phoneNumber: contactInformation.phone
      }
    },
    technicalContact: technicalContactInfo,
    order: {
      servicePeriod: parseInt(servicePeriod),
      specialRequirements: addOns.specialRequirements || '',
      automaticallyRenew: Boolean(automaticallyRenew),
      instanceLaunchDate: instanceLaunchDate,
      instances: _instances,
      addOns: [
        {
          name: 'INTEGRATION_DRIVER',
          value: !!addOns.integrationDriver
        },
        {
          name: 'DHIS2_SUPPORT_PLAN',
          value: !!addOns.dhis2SupportPlan
        }
      ]
    },
    billing: {
      address: billingAddress,
      city: city,
      state: country === USA ? usaState : state,
      zipCode: postalCode,
      country: country,
      poNumber: poNumber,
      frequency: billingFrequency,
      contact: {
        info: {
          name: billingContactName,
          email: billingContactEmail,
          phoneNumber
        }
      },
      createFinanceUser
    }
  };
};


const validateTotalEntity = (order = {}) =>  {
  const { servicePeriod, instances, addOns } = order;
  const hasServicePeriod = servicePeriod !== undefined;
  const hasInstances = Boolean(instances);
  const hasValidAddOns = addOns && addOns.length > 0;
  const hasHostingPlan = instances.every(instance => Boolean(instance.hostingPlan));
  const hasPurchaseDomain = instances.every(instance => instance.purchaseDomain !== undefined);

  return (
    hasServicePeriod &&
    hasInstances &&
    hasValidAddOns &&
    hasHostingPlan &&
    hasPurchaseDomain
  );
};

const mapToTotalEntity = ( formData = {}) => {
  let instances = formData.instances || {};
  instances = instances.instances || {};
  const { addOns } = formData;
  const { servicePeriod } = instances['instancesSetup'] || {};
  const _instances = Object.keys(instances)
    .filter(id => id !== 'instancesSetup')
    .map(instanceId => {
      const { hostingPlan = '', urlType} = instances[instanceId] || {};
      return {
        "hostingPlan": hostingPlan.toLocaleUpperCase(),
        "purchaseDomain": urlType === 'purchaseDomain'
      }
    });

  const order = {
    servicePeriod,
    instances: _instances,
    addOns: [
      {
        name: 'INTEGRATION_DRIVER',
        value: !addOns ? false : !!addOns.integrationDriver
      },
      {
        name: 'DHIS2_SUPPORT_PLAN',
        value: !addOns ? false : !!addOns.dhis2SupportPlan
      }
    ]
  };

  return {
    ready: validateTotalEntity(order),
    order
  };
};

export { mapToFormSubmissionEntity, mapToTotalEntity };
